import axios, { AxiosResponse } from "axios";
import useAuthHeaders from "hooks/useAuthHeader";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useQuery } from "react-query";
import { DashboardStatisticResponse } from "types/dashboard-statistic";

interface UseAllStatisticParams {
    start_date?: string;
    end_date?: string;
}

interface GetAllStatistic extends AxiosResponse {
    data: DashboardStatisticResponse
}

const useAllStatistic = (params: UseAllStatisticParams) => {
    const signOut = useSignOut();
    const headers = useAuthHeaders();

    const queryParams = new URLSearchParams(
        Object.entries(params).reduce((acc, [key, value]) => {
            if (value !== null && value !== undefined) {
                acc[key] = String(value);
            }
            return acc;
        }, {} as Record<string, string>)
    ).toString();

    return useQuery<unknown, unknown, GetAllStatistic>({
        queryKey: ['get-all-statistic', params.start_date, params.end_date],
        queryFn: async () => {
            try {
                return await axios.get(
                    `${process.env.REACT_APP_API_ENDPOINT}/all/statistic?${queryParams}`,
                    { headers }
                );
            } catch (err: any) {
                console.error(err);
                if (err?.response?.status === 401) signOut();
                throw err;
            }
        },
        enabled: !!params.start_date && !!params.end_date, // Only run query if dates are provided
    });
}

export default useAllStatistic;